import { stringify } from 'qs';
import {URL_API} from "../../../url.config";
import {request} from "../../../utils/apiUtils";
let AdSchoolInfoManager = {
    getListSchool: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school/list`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school/delete/${id}`,
            method: 'GET'
        }, callback)
    },
    addYear: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school/add-year/${payload.yearId}?schoolId=${payload.schoolId}`,
            method: 'GET'
        }, callback)
    }
}
export default AdSchoolInfoManager
